const ActionTypes = {
  INIT_STORE: 'INIT_STORE',
  ADD_EMAIL_OR_PHONE: 'ADD_EMAIL_OR_PHONE',
};

export default ActionTypes;
